export default "__VITE_ASSET__DQx1JkWX__"